import React from 'react';

import numeral from 'numeral';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';

import useStyles from '../../styles/textFieldStyle';
import { MARGIN_TOP } from '../../config/constants';

import { FIX_FLIP, CONSTRUCTION } from '../../constants/typeOfHomeOptions';
import { PURCHASE } from '../../constants/pms_purpose_of_loan';

const CalculatedField = ({ values, type_of_loan, purpose_of_loan }) => {
  const classes = useStyles();

  const isFixAndFlip = type_of_loan === FIX_FLIP.value || type_of_loan === CONSTRUCTION.value;

  let ltv = 0;

  if (values.loan_amount !== '' && values.as_is_value !== '') {
    ltv = numeral(values.loan_amount / values.as_is_value).format('0.00%');
  }

  let ltp = 0;

  if (values.loan_amount !== '' && values.purchase_price !== '') {
    ltp = numeral(values.loan_amount / values.purchase_price).format('0.00%');
  }

  let ltv_arv = 0;

  if (
    values.loan_amount !== '' &&
    values.arv_market_value !== '' &&
    type_of_loan === FIX_FLIP.value
  ) {
    //prettier-ignore
    ltv_arv = numeral(values.loan_amount / values.arv_market_value).format("0.00%");
  }

  return (
    <React.Fragment>
      <TextField
        variant="outlined"
        className={[classes.width100, classes.root]}
        InputProps={{
          readOnly: true,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        label="LTV - AS-IS"
        value={ltv}
        style={{ marginTop: MARGIN_TOP }}
      />

      {purpose_of_loan === PURCHASE.value && (
        <TextField
          variant="outlined"
          className={[classes.width100, classes.root]}
          InputProps={{
            readOnly: true,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          label="LTP"
          value={ltp}
          style={{ marginTop: MARGIN_TOP }}
        />
      )}

      {isFixAndFlip && (
        <TextField
          variant="outlined"
          className={[classes.width100, classes.root]}
          InputProps={{
            readOnly: true,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          label="LTV - ARV"
          value={ltv_arv}
          style={{ marginTop: MARGIN_TOP }}
        />
      )}
    </React.Fragment>
  );
};

const mapState = state => {
  return {
    type_of_loan: state.form.accounts.type_of_loan,
    purpose_of_loan: state.consoleBrok1.purpose_of_loan,
  };
};

export default connect(mapState)(CalculatedField);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/CalculatedField.js